/**
 * The investor brief — one address for every footer's "for investors" button: today's site footer
 * (src/components/GlobalFooter.tsx) and the new design's (src/design/pavilion/shell/shellContent.ts re-exports it for
 * PavilionFooter.tsx). Change the brief here and both footers follow. It lives outside the shell because GlobalFooter
 * rides the first download, and importing a shell module would carry the shell into main.js (the bookingCalendar.ts
 * reason). tests/landing/pavilionHomeParity.test.tsx holds both footers to this module.
 */
export const INVESTOR_BRIEF_URL = 'https://brieflink.com/v/7b4v1';
export const INVESTOR_BRIEF_FEATURES =
  'width=1100,height=800,menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=yes';
